import React from 'react';
import CheckboxTreeItem from './CheckboxTreeItem';

export const CheckboxTreeContainer = (props) => {
  return props.nodes.map((parentObj, index) => {
    return (
      <CheckboxTreeItem
        key={parentObj.casId}
        highlightSearch={props.highlightSearch}
        singleSelect={props.singleSelect}
        selectedIds={props.selectedIds}
        hasContainerFocus={props.hasContainerFocus}
        setHasFocus={props.setHasFocus}
        onSelect={props.onSelect}
        hideChild={props.hideChild}
        closeDDM={props.closeDDM}
        closeOnBlurDDM={props.closeOnBlurDDM}
        showChild={props.showChild}
        isAutoExpend={props.isAutoExpend}
        parentObj={parentObj}
        isOpened={props.selectedGroupIds.includes(parentObj.casId)}
        positionIndex={index}
        focus={props.focus}
        setFocusPosition={props.setFocusPosition}
        treeItemsSize={props.nodes.length}
      />
    );
  });
};

export default CheckboxTreeContainer;
